import { render, staticRenderFns } from "./CallOffice.vue?vue&type=template&id=0790e32d&scoped=true&"
import script from "./CallOffice.vue?vue&type=script&lang=js&"
export * from "./CallOffice.vue?vue&type=script&lang=js&"
import style0 from "./CallOffice.vue?vue&type=style&index=0&id=0790e32d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0790e32d",
  null
  
)

export default component.exports